import { spaces } from "./spacing";
import { lightTheme, darkTheme } from "./colors";
import { fonts, fontSizes, fontWeights } from "./fonts";
import { radius } from "./radius";

export const themes = {
  spaces,
  color: lightTheme || darkTheme,
  fonts,
  fontSizes,
  fontWeights,
  radius,
};

export type MyTheme = typeof themes;
